const newsletter = `
# eBL Newsletter 14

## 6 November 2023

### Fragmentarium & Signs

- It is now possible to add dates to Fragmentarium editions: Both the date of a
  tablet (i.e., the date from the date formula, so only one per tablet) and the
  dates mentioned in the text (multiple per tablet) can be entered. The date is
  displayed in the Fragmentarium edition, in the sign display, and also in the
  search.
- The majority of dates in J. Everling’s collection (13,480 tablets) have been
  imported, so most published NB-LB tablets are now linked to a date. The rest
  from the Babylon Collection catalogue are being processed to be imported as
  proper dates. Please let us know if you want to import any list of dated tablets.
- A list is being created of cuneiform documents from the Hellenistic and Parthian
  periods (Daniel López). Also, the signs in documents from these periods are being
  systematically tagged (Ekaterine Gogokhia). If you find any tablet from these
  periods that is not easily found, please let us know.
- ATF: 1⁄4 and 1⁄6 have been added to the grammar.
- The CTMMA 1–4 (Metropolitan Museum) and TCL 6 (Louvre Museum) tablets have been
  imported.
- Resources are now shown explicitly in the left-hand column. The following resources
  have been added so far: BDTNS, Archibab, CDLI, Metropolitan Museum, Penn Museum,
  Achemenet, ORACC, Louvre Museum.
- Only tagged signs that are completely preserved are now being shown in the
  sign list.
- The number of sign annotations has grown exponentially in the last few months,
  thanks to the work of Ekaterine Gogokhia. We have now 48,616 annotated signs:
  - Ur III: 375
  - Old Babylonian: 658
  - Old Assyrian: 329
  - Middle Babylonian: 1,154
  - Neo-Assyrian: 11,472
  - Neo-Babylonian: 20,629
  - Late Babylonian: 2,653
  - Persian: 2,991
  - Hellenistic: 3,426
  - Parthian: 4,929

### Corpus

- A new text has been uploaded to the Corpus: The Syncretistic Hymn to Gula
  ([III.12](https://www.ebl.lmu.de/corpus/L/3/12)) in an edition by E. Bennett.`

export default newsletter
